import { render, staticRenderFns } from "./ResultadosPesquisa.vue?vue&type=template&id=230ec547&"
import script from "./ResultadosPesquisa.vue?vue&type=script&lang=js&"
export * from "./ResultadosPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports